const isInt = (n: any) => Number(n) === n;
export default isInt;
